import { render, staticRenderFns } from "./pdf-viewer.vue?vue&type=template&id=bde5606c"
import script from "./pdf-viewer.vue?vue&type=script&lang=js"
export * from "./pdf-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports